import React from 'react'
import { Box } from '@material-ui/core'
import Fab from '@material-ui/core/Fab'
import AddIcon from '@material-ui/icons/Add'
import CloseIcon from '@material-ui/icons/Close'
import SelectComponent from '../Select'
import AutoCompleteComponent from '../../sharedComponents/AutoCompleteComponent'
import { useStyles } from './styles'

const TabField = props => {
  const { array, field, input1, input2, fields, isCondition, onChangeField, onClearField, addFieldIn } = props

  const classes = useStyles()

  return (
    <>
      {Array.isArray(fields.campos[field][array]) && fields.campos[field][array].length > 0
        ? fields.campos[field][array].map((value, index) => (
            <>
              <section className={classes.fieldList} key={value.campo_id}>
                {/* {!fields.campos[field].campo_display.includes('echa') ? (
                  <> */}
                {isCondition ? (
                  <>
                    <SelectComponent
                      variant="outlined"
                      value={value?.condicion || ''}
                      onChange={event => onChangeField(event.target.value, array, input1, field, index)}
                    />
                  </>
                ) : (
                  <>
                    <AutoCompleteComponent
                      variant="outlined"
                      value={value?.desde || ''}
                      options={fields.campos[field].autocompletar}
                      onChange={(event, newValue) => onChangeField(newValue, hasta, input1, field, index)}
                    />
                  </>
                )}
                <AutoCompleteComponent
                  variant="outlined"
                  value={isCondition ? value?.desde || '' : value?.hasta || ''}
                  options={fields.campos[field].autocompletar}
                  onChange={(event, newValue) => onChangeField(newValue, array, input2, field, index)}
                />
                <Box>
                  <Fab
                    size="small"
                    onClick={() => onClearField(array, field, index)}
                    className={classes.buttonDelete}
                    aria-label="cerrar"
                  >
                    <CloseIcon />
                  </Fab>
                  <Fab
                    size="small"
                    onClick={() => addFieldIn(array, field, index)}
                    color="secondary"
                    aria-label="add"
                    className={classes.addRow}
                  >
                    <AddIcon />
                  </Fab>
                </Box>
              </section>
            </>
          ))
        : [1, 2].map((value, index) => (
            <section className={classes.fieldList} key={value}>
              {isCondition ? (
                <>
                  <SelectComponent
                    variant="outlined"
                    onChange={event => onChangeField(event.target.value, array, input1, field, index)}
                  />
                </>
              ) : (
                <>
                  <AutoCompleteComponent
                    variant="outlined"
                    options={fields.campos[field]?.autocompletar}
                    onChange={(event, newValue) => onChangeField(newValue, array, input1, field, index)}
                  />
                </>
              )}
              <AutoCompleteComponent
                variant="outlined"
                options={fields.campos[field]?.autocompletar}
                onChange={(event, newValue) => onChangeField(newValue, array, input2, field, index)}
              />
              <Box>
                <Fab
                  size="small"
                  onClick={() => onClearField(array, field, index)}
                  className={classes.buttonDelete}
                  aria-label="cerrar"
                >
                  <CloseIcon />
                </Fab>
                <Fab
                  size="small"
                  onClick={() => addFieldIn(array, field, index)}
                  color="secondary"
                  aria-label="add"
                  className={classes.addRow}
                >
                  <AddIcon />
                </Fab>
              </Box>
            </section>
          ))}
    </>
  )
}

export default TabField
